import React, { useState } from "react";
import "../styles/App.css";
import EditProfile from "./EditProfile";
import CreateAdmin from "./CreateAdmin";
import CreateClinic from "./CreateClinic";
import CreatePharmacy from "./CreatePharmacy";
import CreateMedication from "./CreateMedication";
import CreateClinicManager from "./CreateClinicManager";
import CreateProvider from "./CreateProvider";
import CreateQuestionnaire from "./CreateQuestionnaire";
import useCurrentProvider from "../hooks/useCurrentProvider";

interface UserProps {
  id: string;
  firstName: string;
  lastName: string;
  phone?: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
  email: string;
  user: {
    email: string;
    createdAt: string;
    role: string;
  };
  clinic?: {
    clinicName: string;
    clinicCode: string;
  };
}

interface UserActionsProps {
  admin?: UserProps;
  clinicManager?: UserProps;
}

const UserActionsContainer: React.FC<UserActionsProps> = ({
  admin,
  clinicManager,
}) => {
  const [activeAction, setActiveAction] = useState<string | null>(null);
  const { user, isAdmin, isClinic } = useCurrentProvider();

  const userProfile = admin || clinicManager;
  if (!userProfile || (!isAdmin && !isClinic)) return null;

  const renderActionComponent = () => {
    switch (activeAction) {
      case "editProfile":
        return <EditProfile user={userProfile} />;
      case "createAdmin":
        return <CreateAdmin />;
      case "createClinic":
        return <CreateClinic />;
      case "createPharmacy":
        return <CreatePharmacy />;
      case "createMedication":
        return <CreateMedication />;
      case "createProvider":
        return (
          <CreateProvider
            clinicCode={clinicManager?.clinic?.clinicCode ?? ""}
          />
        );
      case "createClinicManager":
        return <CreateClinicManager />;
      case "createQuestionnaire":
        return <CreateQuestionnaire />;
      default:
        return <p>Select an action to begin.</p>;
    }
  };

  return (
    <div className="admin-actions-container">
      <h2>Actions</h2>
      <div className="admin-actions-buttons">
        <button onClick={() => setActiveAction("editProfile")}>
          Edit Profile
        </button>
        {/* Admin-only buttons */}
        {isAdmin && (
          <>
            <button onClick={() => setActiveAction("createAdmin")}>
              Add Admin
            </button>
            <button onClick={() => setActiveAction("createClinic")}>
              Add Clinic
            </button>
            <button onClick={() => setActiveAction("createPharmacy")}>
              Add Pharmacy
            </button>
            <button onClick={() => setActiveAction("createMedication")}>
              Add Medication
            </button>
            {/* New Questionnaire creation/edit button */}
            <button onClick={() => setActiveAction("createQuestionnaire")}>
              Create/Edit Questionnaire
            </button>
          </>
        )}
        {/* Shared buttons */}
        <button onClick={() => setActiveAction("createProvider")}>
          Add Clinic Provider
        </button>
        <button onClick={() => setActiveAction("createClinicManager")}>
          Add Clinic Manager
        </button>
      </div>
      <div className="admin-action-content">{renderActionComponent()}</div>
    </div>
  );
};

export default UserActionsContainer;
